<template>
    <div class="mx-auto col-lg-6 col-md-8 col-sm-12 header-margin">
        <div class="text-center p-5">
            
            <div class="text-center p-2">
                <h3>{{ $t('account.password.title') }}</h3>
            </div>
        
            <div class="text-center p-2">
                {{ $t('account.password.text') }}
            </div>
        
        </div>

        <div class="text-center">
            <div class="pb-4 ">
                <!-- <button id="top" @click="handleOnClickLogout()" class="btn btn-primary"> -->
                <router-link to="/" id="top" class="btn btn-primary" role="button" @click.native="handleOnClickLogout()">{{$t('account.password.butlogin') }}</router-link>
                    
                <!-- </button> -->
            </div>
        </div>
    </div>
</template>

<script>
    import AuthUtil from '../../utils/AuthUtil';
    import UserService from "../../services/UserService";

    export default {
        name: 'edit-user-profile-module',
        methods: {
            async handleOnClickLogout(e) {
                try {
                    await UserService.revokeToken(AuthUtil.getAuthToken());
                } catch (e) {}
                AuthUtil.clearAuth();
                this.isOpenMenu = false;
                this.$router.push('/login');
            },
        }
    }
</script>
